import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core/lib";
import { find } from "lodash";
import { h } from "preact";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import { BarChartOpt } from "../../common/components/BarChartOpt";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
} from "../../common/generic/generic-helper";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { NBIKpis } from "../../common/generic/generic-nbi-domains";
import { IGenericRequest } from "../../common/generic/generic-types";
import {
  BuildPortfolioFilters,
  GetPortfolioFilterAsofDate,
} from "../../common/portfolio/portfolio-filter";
import { IProps } from "../../common/portfolio/portfolio-types";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";
import { BuildCumulativeOptions, MapData } from "../utils/helper";

export interface IState {
  data?: any;
  symbolLabel: string;
  xLabels: string[];
}

export class PortfolioCumulativeNbiClass extends ApiBackedComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  public constructor() {
    super();
    this.setState({
      data: {},
      symbolLabel: "K",
      xLabels: [],
    });
  }

  protected renderWithDataReady(): JSX.Element {
    return <BarChartOpt options={this.state.data} />;
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    const headers = props.headers;
    const dimention = new NbiDimensions();
    const nbiKpis = new NBIKpis();
    const indicator = "nbi";
    const kpis = [nbiKpis.NBI_YTD, nbiKpis.NBI_FY_1, nbiKpis.NBI_FY_2];
    const attributes = [
      dimention.PERIOD_MONTH_ID,
      dimention.PERIOD_MONTH_LABEL,
    ];
    const filters = BuildPortfolioFilters(props.filters);
    this.setDataStatus("loading");
    const genericRequest: IGenericRequest = {
      aggregationAttributes: attributes.join(","),
      date: GetPortfolioFilterAsofDate(props.filters),
      filter: GenericFilterBuilder(filters),
      kpis: kpis.join(","),
      sort: "period_month_id",
    };
    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setState({
        data: [],
      });
      this.setDataStatus("too-many-clients");
    } else {
      const responseData = await MakeGenericApiCall(
        headers,
        indicator,
        genericRequest,
        this.props.widgetConfiguration,
        this.state.correlationId
      );
      const errorStatus = CheckReponseDataForError(responseData);
      if (errorStatus) {
        this.setDataStatus(errorStatus);
        this.setStatusText(responseData.statusText);
        this.setState({
          data: [],
        });
      } else {
        const result = MapData(responseData);
        if (result !== undefined) {
          const chartOptions = BuildCumulativeOptions(result);
          this.setState({
            data: chartOptions,
          });
          this.setDataStatus("ready");
        } else {
          this.setState({
            data: [],
          });
          this.setDataStatus("no-data");
        }
      }
    }
  }
}

export const PortfolioCumulativeNbi = withWidgetConfiguration(
  PortfolioCumulativeNbiClass
);
